import { configSettings } from './config-settings'
export default {
	install: app => {
		// Set default configuration
		window.stanCookieBannerConfig = {
			colors: {
				'button-border': 'var(--stan-primary-dark-color)',
				'banner-background': 'var(--stan-white)',
				'button-background': 'var(--stan-white)',
				'text-primary': 'var(--stan-text-dark-color)',
				'button-text': 'var(--stan-white)',
				'modal-background': 'var(--stan-white)',
				'border-color': 'var(--stan-gray-soft-color)',
				'toggle-background': 'var(--stan-gray-dark-color)',
				'toggle-active': 'var(--stan-primary-primary-color)',
				'toggle-disabled': 'var(--stan-primary-soft-color)',
			},
			'cookie-policy-url': 'https://terms.stan.store/privacy',
			'cookie-terms-url': 'https://terms.stan.store/terms',
		}

		// Load the cookie banner script
		const script = document.createElement('script')
		script.src = configSettings.stanCookieBannerUrl
		script.async = true
		script.onload = () => {
			// Initialize cookie banner after script loads
			if (window.CookieBanner) {
				setTimeout(() => {
					new CookieBanner()
				}, 1000)
			}
		}
		document.addEventListener('cookie-modal-shown', () => {
			document.documentElement.style.overflow = 'hidden'
		})
		document.addEventListener('cookie-modal-hidden', () => {
			document.documentElement.style.overflow = ''
		})
		document.head.appendChild(script)
	},
}
